import React from 'react';
import classNames from 'classnames';

import { getVideoPlayIcon } from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import {
  getInternalLinkUrl
} from 'zoomforth_codesbane_viewer/lib/app_actions.js';

import {
  VisuallyHiddenSpan
} from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const SlideshowThumbnail_ViewerVersion1 = ({
  uuid,
  isActive,
  isVideo,
  imgSrc,
  children,
  onClick
})=> (
  <div
    onClick={onClick}
    className={classNames('galleria-image', {
      active: isActive,
      [`content-uuid-${uuid}`]: !!uuid
    })}
  >

    {
      isVideo &&
      <img
        className="video-icon"
        src={getVideoPlayIcon()}
      />
    }

    <img
      src={imgSrc}
      className="thumbnail"
    />

    { children }
  </div>
);

const SlideshowThumbnail_ViewerVersion2 = ({
  contentItem,
  asset,
  idx,
  isActive,
  isVideo,
  subpageId,
  children,
  onClick,
  onSelectContentClick
})=> (
  <a
    className={classNames('accessible-slideshow-btn accessible-slideshow-thumbnail', {
      'is-active': isActive,
      [`content-uuid-${contentItem.uuid}`]: contentItem && contentItem.uuid
    })}
    href={getInternalLinkUrl({ subpageId, contentUuid: contentItem.uuid })}
    onClick={(e)=> {
      e.preventDefault();
      onClick();
      if (onSelectContentClick) {
        onSelectContentClick(contentItem, { shouldSyncUrl: false });
      }
    }}
  >
    {
      isVideo &&
        <img
          className="video-icon"
          src={getVideoPlayIcon()}
        />
    }

    <img
      alt={`Slide ${idx + 1}`}
      className="display-image"
      src={contentItem.thumbnail || (asset && asset.thumbnail)}
    />

    <VisuallyHiddenSpan>
      Slide { idx + 1 }
    </VisuallyHiddenSpan>

    { children }
  </a>
);

const SlideshowThumbnail = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SlideshowThumbnail_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SlideshowThumbnail_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SlideshowThumbnail;
